/* import __COLOCATED_TEMPLATE__ from './remove-conversation-priority.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
}

const RemoveConversationPriorityNodeItem = templateOnlyComponent<Signature>();
export default RemoveConversationPriorityNodeItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::RemoveConversationPriority': typeof RemoveConversationPriorityNodeItem;
    'workflows/graph-editor/node-items/steps/remove-conversation-priority': typeof RemoveConversationPriorityNodeItem;
  }
}
